import { render, staticRenderFns } from "./ChatTemplate.vue?vue&type=template&id=f1341a78&"
import script from "./ChatTemplate.vue?vue&type=script&lang=ts&"
export * from "./ChatTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ChatTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports